"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Title = _interopRequireDefault(require("../../media/models/Title"));

var _TitleCard = _interopRequireDefault(require("../../media/TitleCard"));

var _TitleActions = _interopRequireDefault(require("../../../title-actions/TitleActions"));

var _Campaign = _interopRequireDefault(require("../templates/Campaign.html"));

var _svgLoader = _interopRequireDefault(require("../../../util/svgLoader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Campaign =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(Campaign, _Backbone$View);

  _createClass(Campaign, [{
    key: "roomClass",
    get: function get() {
      return this.currentRoom ? "is-".concat(this.currentRoom.themeName) : '';
    }
  }]);

  function Campaign(_ref) {
    var _this;

    var bus = _ref.bus,
        currentRoom = _ref.currentRoom,
        campaign = _ref.campaign;

    _classCallCheck(this, Campaign);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Campaign).apply(this, arguments));
    _this.bus = bus;
    _this.currentRoom = currentRoom;
    _this.campaign = campaign;
    _this.model = _this.model || new _Title["default"]();
    _this.titleActions = new _TitleActions["default"]({
      bus: _this.bus
    });
    _this.titleCard = new _TitleCard["default"]({
      model: _this.model
    });

    _this.listenTo(_this.model, 'title:action', _this._handleTitleAction);

    return _this;
  }

  _createClass(Campaign, [{
    key: "render",
    value: function render() {
      var $campaign = $((0, _Campaign["default"])(this));
      this.model.setContext({
        campaign: this.campaign
      });
      $campaign.find('.Campaign-fullCoverContainer').append(this.titleCard.render().el);
      this.$el.empty().append($campaign);
      (0, _svgLoader["default"])();
    }
  }, {
    key: "_handleTitleAction",
    value: function _handleTitleAction(_ref2) {
      var action = _ref2.action,
          model = _ref2.model;
      this.titleActions.perform(action, model);
    }
  }]);

  return Campaign;
}(Backbone.View);

exports["default"] = Campaign;